export const SUCCESS_TIME_MESSAGE = 5000;
export const SUCCESS_WARNING_TIME_MESSAGE = 10000;
export const ERROR_TIME_MESSAGE = 10000;
export const NOTIFICATION_H_POS = 'center';
export const NOTIFICATION_V_POS = 'top';

export const LIMIT_SEARCH_WELL = 10;
export const OFFSSET_SEARCH_WELL = 1;
export const MIN_LENGTH_SEARCH = 3;
export const PERMISSION_CREATE_HO = 'Crear HO';
export const PERMISSION_CREATE_HO_ID = 1;
export const PERMISSION_RELEASE_HO_ID = 7;
export const PERMISSION_HO_TEAM_ID = 12;
export const PERMISSION_EDIT_HO = 2;
export const PERMISSION_SEND_HO = 3;
export const PERMISSION_ACCEPT_HO = 4;
export const PERMISSION_CLAIM_HO = 5;
export const PERMISSION_CANCEL_HO = 6;
export const PERMISSION_CANCEL_REJECTED_HO = 13;
export const PERMISSION_DELETE_DRAFT_HO = 6;
export const PERMISSION_VIEW_EMITTED_HO = 8;
export const PERMISSION_VIEW_RECEIVED_HO = 9;
export const PERMISSION_WELL_SEARCH = 10;
export const PERMISSION_VIEW_HISTORY_HO = 11;
export const PERMISSION_TO_DOWLOAD = 14;
export const PERMISSION_ENGINEERING_COMPLETION = 15;
export const PERMISSION_CREATE_HO_LOC = 16;
export const ROLE_SUPERVISOR = 'Supervisor';
export const ROLE_OPERATIVO = 'Operativo';
export const ROLE_VISUALIZA_HOME = 'Home';
export const ROLE_CREACION = 'Creacion';
export const ROLE_CONSULTA = 'Consulta';
export const ROLE_SUPERVISOR_ID = 1;
export const ROLE_OPERATIVO_ID = 2;
export const ROLE_VISUALIZA_HOME_ID = 3;
export const ROLE_CONSULTA_ID = 5;
export const MANAGEMENT_UNIT_NQN_GSJ = '';
export const MANAGEMENT_UNIT_NQN = 'NQN';
export const MANAGEMENT_UNIT_ACA = 'ACA';
export const MANAGEMENT_UNIT_HOC = 'HOKCHI';
export const MANAGEMENT_UNIT_GSJ = 'GSJ';
export const WITHOUT_MANAGEMENT_UNIT = 'S/UG';

// IDs de Areas Operacionales
export const OPERATIONAL_AREA_DRILLING_ID = 1;
export const OPERATIONAL_AREA_COMPLETION_ID = 2;
export const OPERATIONAL_AREA_OPERATIONS_ID = 3;
export const OPERATIONAL_AREA_PULLING_ID = 4;
export const OPERATIONAL_AREA_WELL_SERVICE_ID = 5;
// Handover specific statuses
export const HANDOVER_STATUS_CREATED = 1;
export const HANDOVER_STATUS_TAKE_PENDING = 2;
export const HANDOVER_STATUS_TAKEN = 3;
export const HANDOVER_STATUS_ACCEPTED = 4;
export const HANDOVER_STATUS_REJECTED = 5;
export const HANDOVER_STATUS_CANCELED = 6;

// Declarar los IDs de md_handover_status para los cuales
// tenemos que mostrar el footer en detalle de handover.
export const HANDOVER_STATUSES_DISPLAY_FOOTER = [
  HANDOVER_STATUS_TAKEN,
  HANDOVER_STATUS_REJECTED,
];
export const HANDOVER_STATUSES_EDITABLES = [
  HANDOVER_STATUS_CREATED,
  HANDOVER_STATUS_REJECTED,
];

export const HANDOVER_STATUSES_EDITABLES_HO3 = [
  HANDOVER_STATUS_CREATED,
  HANDOVER_STATUS_TAKE_PENDING,
  HANDOVER_STATUS_REJECTED,
];

export const DHO_DATEPICKER_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MM/YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MM/YYYY',
  },
};
// Handover Types ID
export const HANDOVER_TYPE_HO1_ID = 1;
export const HANDOVER_TYPE_HO2_ID = 2;
export const HANDOVER_TYPE_HO3_ID = 3;
export const HANDOVER_TYPE_HO4_ID = 4;
export const HANDOVER_TYPE_HO5_ID = 5;
export const HANDOVER_TYPE_HOG_ID = 6;
export const HANDOVER_TYPE_HOEC_ID = 7;
export const HANDOVER_TYPE_HOAC_ID = 8;
export const HANDOVER_TYPE_HLOC0_ID = 9;
export const HANDOVER_TYPE_HLOC_ID = 10;
export const HANDOVER_TYPE_HO2_LOC_ID = 11;
export const HANDOVER_TYPE_HO1_LOC_ID = 12;
export const HANDOVER_TYPE_HOG_LOC_ID = 13;
export const HANDOVER_TYPE_HO4_LOC_ID = 14;
export const HANDOVER_TYPE_HO5_LOC_ID = 15;

export const HANDOVER_EMITTER = 'Emitter';
export const HANDOVER_RECEIVER = 'Receiver';

export const PAE_SUPPORT_EMAIL = 'HHelpDWHO@pan-energy.com';

// Notification types
export const HANDOVER_TYPE_IDS_WITH_NOTIFICATIONS = [1, 2, 3, 4, 6, 7, 8];
export const HANDOVER_NOTIFICATION_TYPE_TOGGLE = 'toggle';
export const HANDOVER_NOTIFICATION_TYPE_COMMENT = 'comment';
export const HANDOVER_NOTIFICATION_TYPE_COMMENT_OFF = 'comment_off';
export const HANDOVER_NOTIFICATION_TYPE_FILE = 'file';
export const HANDOVER_NOTIFICATION_TYPE_FILE_WITH_TOGGLE = 'file_with_toggle';
export const HANDOVER_NOTIFICATION_TYPE_RADIO = 'radio';
export const HANDOVER_NOTIFICATION_TYPE_SELECT = 'select';
export const HANDOVER_NOTIFICATION_WELL_TYPE_OTHER_IDS = [10, 13];
export const HANDOVER_NOTIFICATION_SELECT_OTHER_OPTIONS = ['Otro'];
export const HANDOVER_NOTIFICATION_WELL_CONTROL_EVENT_ID = 1; // "Ocurrió evento de Control de Pozo"

// Observations Type
export const HANDOVER_OBSERVATION_DATA = 1;
export const HANDOVER_OBSERVATION_DATA_DIALOG_TITLE =
  'Historial de Observaciones en Datos del Handover:';
export const HANDOVER_OBSERVATION_WELL_CONDITION = 2;
export const HANDOVER_OBSERVATION_WELL_CONDITION_DIALOG_TITLE =
  'Historial de Observaciones en Condición de Pozo:';

// Cementing Top-Job
export const CEM_TOP_JOB_TYPE_YES = 'Si';
export const CEM_TOP_JOB_TYPE_INDETERMINATE = 'Indeterminado';
export const CEM_TOP_JOB_TYPE_NOT_APPLY = 'No Aplica';

// Handover Type Area Reason IDs
export const HANDOVER_TYPE_AREA_REASON_2_CWO_TO_OPE_ID = 3;
export const HANDOVER_TYPE_AREA_REASON_4_CWO_TO_OPE_ID = 4;
export const HANDOVER_TYPE_AREA_REASON_4_PUL_TO_OPE_ID = 6;
export const HANDOVER_TYPE_AREA_REASON_3_OPE_TO_CWO_ID = 8;
export const HANDOVER_TYPE_AREA_REASON_3_OPE_TO_PUL_ID = 9;
export const HANDOVER_TYPE_AREA_REASON_7_CWO_TO_OPE_ID = 12;
export const HANDOVER_TYPE_AREA_REASON_8_OPE_TO_CWO_ID = 13;
export const HANDOVER_TYPE_AREA_REASON_9_FAC_TO_DR_ID = 14;
export const HANDOVER_TYPE_AREA_REASON_10_OP_TO_PUL = 15;
export const HANDOVER_TYPE_AREA_REASON_11_CWO_TO_OPE_ID = 17;
export const HANDOVER_TYPE_AREA_REASON_12_DRL_TO_CWO_ID = 18;
export const HANDOVER_TYPE_AREA_REASON_13_DRL_TO_DRL_ID = 19;
export const HANDOVER_TYPE_AREA_REASON_14_CWO_TO_OPE_ID = 20;
export const HANDOVER_TYPE_AREA_REASON_15_MC_TO_OPE_ID = 21;

export const HANDOVER_REASON_NAME_HOAC = 'A Completar (HOAC)';
// Tooltips permissions

export const HANDOVER_SEND_OPERATIONS_PERMISSION_DENIED =
  'Para Enviar, el Pozo debe pertenecer a un Distrito/Asset que coincida con el del Perfil de algún Usuario de Operaciones';

export const HANDOVER_INITIATE_VALIDATION_TYPE_HOG = 'hogIni';
export const HANDOVER_SEND_VALIDATION_TYPE_HOG = 'hogEnv';
export const HANDOVER_INITIATE_VALIDATION_TYPE_HO1 = 'ho1Ini';
export const HANDOVER_INITIATE_VALIDATION_TYPE_HO1_LOC = 'ho1LocIni';
export const HANDOVER_SEND_VALIDATION_TYPE_HO1 = 'ho1Env';
export const HANDOVER_INITIATE_VALIDATION_TYPE_HO2 = 'ho2Ini';
export const HANDOVER_INITIATE_VALIDATION_TYPE_HO2_LOC = 'ho2LocIni';
export const HANDOVER_SEND_VALIDATION_TYPE_HO2 = 'ho2Env';
export const HANDOVER_INITIATE_VALIDATION_TYPE_HO4_PULLING = 'ho4PuIni';
export const HANDOVER_SEND_VALIDATION_TYPE_HO4_PULLING = 'ho4PuEnv';
export const HANDOVER_INITIATE_VALIDATION_TYPE_HO4_WORKOVER = 'ho4WoIni';
export const HANDOVER_INITIATE_VALIDATION_TYPE_HO4_WORKOVER_LOC = 'ho4WoIni';
export const HANDOVER_SEND_VALIDATION_TYPE_HO4_WORKOVER = 'ho4WoEnv';
export const HANDOVER_INITIATE_VALIDATION_TYPE_HO5 = 'ho5Ini';
export const HANDOVER_INITIATE_VALIDATION_TYPE_HO5_LOC = 'ho5Ini';
export const HANDOVER_SEND_VALIDATION_TYPE_HO5 = 'ho5Env';
export const HANDOVER_INITIATE_VALIDATION_TYPE_RE = 'reIni';
export const HANDOVER_VALIDATION_TYPE_RE_DATE = 'reFecha';

export const HANDOVER_REJECT_OK_MESSAGE =
  'Al rechazar, los motivos descriptos llegarán al emisor del HO';
export const HANDOVER_REJECT_NOT_OK_MESSAGE =
  'Indicá uno o más motivos para poder rechazar este Handover';

export const HANDOVER_SECTION_GENERAL = 12;

// Esquema de Cabezal - opciones del desplegable "Sección".
// Conjunto fijo y propio de esta sección: no usa md_wellhead_section_name,
// cuyos valores corresponden a la tabla principal de Cabezal.
export const WELLHEAD_SCHEME_SECTIONS = [
  { sectionId: 1, sectionName: 'A' },
  { sectionId: 2, sectionName: 'B' },
  { sectionId: 3, sectionName: 'C' },
  { sectionId: 4, sectionName: 'D' },
  { sectionId: 5, sectionName: 'E' },
];

// Espacios Anulares - subsección "Pozos Inyectores".
// Se muestra sólo para pozos Inyectores o pozos de la UG GSJ.
export const WELL_TYPE_NAME_INJECTOR = 'Inyector';
// Único anular declarable: el que va entre Csg Guía y Csg Aislación.
// El id 1 (Casing Guía) se dio de baja de la pantalla el 22/09/2026 porque ese
// espacio está cementado y fuera del cabezal; puede seguir existiendo en filas
// guardadas antes de esa fecha.
export const ANNULUS_INJECTOR_ANNULAR_TYPE_ISOLATION_CASING_ID = 2;

export const ENGINEERING_DEPARTMENT_OBSERVATION = 'ENGINEERING';
export const OPERATIONS_DEPARTMENT_OBSERVATION = 'OPERATIONS';
export const ALL_DEPARTMENT_OBSERVATION = '';

export const HANDOVER_LOCATION_SECTION_ID = 13;
